import {
  getCurrentFocusKey,
  setFocus,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"

import { Pages } from "../App"
import useTranslate, { Namespaces } from "../hooks/use-translate"
import { appStore, DGPrompt } from "../store/AppStore"
import { CuratedContentSlugV2 } from "../utilities/common"
import { captureSentryException } from "../utilities/sentry"

import { PromptModal } from "./Prompt/PromptModal"

export const NotFound = () => {
  const returnFocus = getCurrentFocusKey()
  const navigate = useNavigate()
  const t_common = useTranslate(Namespaces.Common)
  const setSpinner = appStore((state) => state.setSpinner)
  const setPrompt = appStore((state) => state.setPrompt)
  const t = useTranslate()
  useEffect(() => {
    captureSentryException("404- page not found")
    setSpinner("out")
    setPrompt(prompt)
  }, [])
  const onClose = () => {
    if (returnFocus) {
      navigate(-1)
      setFocus(returnFocus)
      return
    }
    navigate(`/${Pages.Home}`)
    setFocus("TABBAR:" + CuratedContentSlugV2.Discover)
  }
  const prompt: DGPrompt = useMemo(
    () => ({
      title: t_common("error_page_404__title"),
      message: t_common("error_page_404__message"),
      icon: "ERROR",
      dismissible: false,
      canClose: false,
      onConfirm: onClose,
      onClose,
      open: true,
      confirmButtonText: t("tv__pin_login_error_go_back"),
    }),
    [],
  )
  return <PromptModal />
}
